export default __webpack_public_path__ + "static/logo-reserve-2fc6626aa6063f986b1bf38e2222b730.svg";